import { Theme } from "@mui/material/styles"; 

const BookingTypeStyle = (theme: Theme) => ({
  root: {
    py: { xs: 2, sm: 3, md: 4 },
  },

  // Back link (top-left)
  backLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    cursor: "pointer",
    color: "text.secondary",
    mb: { xs: 1.5, sm: 2 },
    "&:hover": { color: "text.primary" },
  },
  backIcon: {
    fontSize: "1rem",
  },

  // HERO IMAGE (auto-fits; no hardcoded sizes)
  imageContainer: {
    position: "relative",
    overflow: "hidden",
    borderRadius: theme.shape.borderRadius,
    width: "100%",
    aspectRatio: "4 / 3",                 // phone/tablet
    [theme.breakpoints.up("sm")]: {
      aspectRatio: "16 / 9",              // desktop
    },
    boxShadow: theme.shadows[1],
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  businessImage: {
    // Fills container, keeps top visible (prevents important heads/titles being cropped)
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "top center",
    display: "block",
    userSelect: "none",
  },
  imageNavButtonLeft: {
    position: "absolute",
    top: "50%",
    left: 8,
    transform: "translateY(-50%)",
    zIndex: 2,
    bgcolor: "rgba(0,0,0,0.35)",
    color: "#fff",
    "&:hover": { bgcolor: "rgba(0,0,0,0.55)" },
  },
  imageNavButtonRight: {
    position: "absolute",
    top: "50%",
    right: 8,
    transform: "translateY(-50%)",
    zIndex: 2,
    bgcolor: "rgba(0,0,0,0.35)",
    color: "#fff",
    "&:hover": { bgcolor: "rgba(0,0,0,0.55)" },
  },

  // Tabs
  tabsContainer: {
    mt: { xs: 1.5, sm: 2 },
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  // Right column cards
  businessDetails: {
    p: { xs: 2, sm: 3 },
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1.25,
  },
  aboutUs: {
    p: { xs: 2, sm: 3 },
    mt: { xs: 2, sm: 3 },
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1.25,
  },
  workingHours: {
    p: { xs: 2, sm: 3 },
    mt: { xs: 2, sm: 3 },
    borderRadius: 2,
  },

  sectionTitle: {
    fontWeight: 700,
    letterSpacing: 0.2,
  },
});

export default BookingTypeStyle;
